import { render, staticRenderFns } from "./TransactionFailed.vue?vue&type=template&id=43c859de&scoped=true&"
import script from "./TransactionFailed.vue?vue&type=script&lang=js&"
export * from "./TransactionFailed.vue?vue&type=script&lang=js&"
import style0 from "./TransactionFailed.vue?vue&type=style&index=0&id=43c859de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c859de",
  null
  
)

export default component.exports